import { render, staticRenderFns } from "./PackagesPriceEditor.vue?vue&type=template&id=3cca5c8b&scoped=true"
import script from "./PackagesPriceEditor.vue?vue&type=script&lang=js"
export * from "./PackagesPriceEditor.vue?vue&type=script&lang=js"
import style0 from "./PackagesPriceEditor.vue?vue&type=style&index=0&id=3cca5c8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cca5c8b",
  null
  
)

export default component.exports